var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeSvg4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_281_32",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2.83333C2 2.61232 2.08872 2.40036 2.24665 2.24408C2.40457 2.0878 2.61877 2 2.84211 2H7.89474L10 4.5H17.1579C17.3812 4.5 17.5954 4.5878 17.7534 4.74408C17.9113 4.90036 18 5.11232 18 5.33333V16.1667C18 16.3877 17.9113 16.5996 17.7534 16.7559C17.5954 16.9122 17.3812 17 17.1579 17H2.84211C2.61877 17 2.40457 16.9122 2.24665 16.7559C2.08872 16.5996 2 16.3877 2 16.1667V2.83333Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89478 8.66666L12.1053 12.8333M12.1053 8.66666L7.89478 12.8333",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_281_32)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.105225 -0.5H20.1053V19.5H-0.105225V-0.5Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeSvg4);
export default __webpack_public_path__ + "static/media/home-svg-4.8673ca99feb2672ad2a0a59f3cd36617.svg";
export { ForwardRef as ReactComponent };